const FE_AF_SearchType = Object.freeze({
  Inventory: 1,
  Request: 2,
});
export default FE_AF_SearchType;
